var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "cs-overlay-wrapper"
  }, [!_vm.loading ? _vm._t("default") : _vm._e(), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.loading,
      expression: "loading"
    }],
    ref: "overlay",
    staticClass: "cs-overlay"
  }, [_c('div', [_vm._m(0), _c('svg', {
    attrs: {
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('defs', [_c('filter', {
    attrs: {
      "id": "goo"
    }
  }, [_c('feGaussianBlur', {
    attrs: {
      "in": "SourceGraphic",
      "result": "blur",
      "stdDeviation": "12"
    }
  }), _c('feColorMatrix', {
    attrs: {
      "in": "blur",
      "mode": "matrix",
      "values": "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 18 -7",
      "result": "goo"
    }
  })], 1)])])])])], 2);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "cssload-dots"
  }, [_c('div', {
    staticClass: "cssload-dot"
  }), _c('div', {
    staticClass: "cssload-dot"
  }), _c('div', {
    staticClass: "cssload-dot"
  }), _c('div', {
    staticClass: "cssload-dot"
  }), _c('div', {
    staticClass: "cssload-dot"
  })]);
}]

export { render, staticRenderFns }